import { c as _c } from "react/compiler-runtime";
import { requestIdleCallback } from '@cc-shopping/utils/requestIdleCallback';
import { RadioGroup } from '@mui/material';
import type { ChangeEvent } from 'react';
import { useFiltersAnalytics } from 'src/features/roundup-filters/store/hooks/useFiltersAnalytics';
import { useShallow } from 'zustand/shallow';
import { SORT_BY_OPTIONS } from '../../../config';
import { useOffersFilterStore } from '../../../store/Context';
import { FilterType, type SortOffersByType } from '../../../store/enums';
import type { OffersFilterStoreState } from '../../../store/types';
import { Accordion } from '../InputAccordion/Accordion';
import { FormLabeledListItem } from '../InputAccordion/FormLabeledListItem';
import { RadioButton } from '../InputAccordion/SimpleSelect/RadioButton';
export function SortBy() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Accordion title="Sort by"><SortByWrapper id="sort-by">{SORT_BY_OPTIONS.map(_temp)}</SortByWrapper></Accordion>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(option) {
  return <FormLabeledListItem key={option.value} control={<RadioButton value={option.value} />} label={option.label} value={option.value} />;
}
function SortByWrapper(t0) {
  const $ = _c(9);
  const {
    id,
    children
  } = t0;
  const {
    sortBy,
    handleApplyFilters,
    handleSingleFormUpdate
  } = useOffersFilterStore(useShallow(_temp2));
  const {
    fireSortByUpdateEvents
  } = useFiltersAnalytics();
  let t1;
  if ($[0] !== fireSortByUpdateEvents || $[1] !== handleApplyFilters || $[2] !== handleSingleFormUpdate) {
    t1 = (_, value) => {
      const typedValue = value as SortOffersByType;
      handleSingleFormUpdate({
        value: typedValue,
        type: FilterType.SORT_BY
      });
      requestIdleCallback(() => {
        handleApplyFilters();
        fireSortByUpdateEvents(typedValue);
      });
    };
    $[0] = fireSortByUpdateEvents;
    $[1] = handleApplyFilters;
    $[2] = handleSingleFormUpdate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleChange = t1;
  let t2;
  if ($[4] !== children || $[5] !== handleChange || $[6] !== id || $[7] !== sortBy) {
    t2 = <RadioGroup name={id} value={sortBy} onChange={handleChange}>{children}</RadioGroup>;
    $[4] = children;
    $[5] = handleChange;
    $[6] = id;
    $[7] = sortBy;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp2(state) {
  return {
    handleApplyFilters: state.handleApplyFilters,
    handleSingleFormUpdate: state.handleSingleFormUpdate,
    sortBy: state.filterFormState.sortBy
  };
}